( function ( $ ) {
	const bbd = $('#billing_birthday_field #billing_birthday');
	bbd.inputmask('99.99.9999', {
		"placeholder": "TT.MM.JJJJ",
	});
} )( jQuery );
